import { css, useTheme } from '@emotion/react';
import { breakpoint } from '~/styles/themes';

interface GlobalFloatLayoutProps {
  children: React.ReactNode;
  type?: 'header' | 'navigation';
  transparentBg?: boolean;
}

export default function GlobalFloatLayout({
  children,
  type = 'header',
  transparentBg = false,
}: GlobalFloatLayoutProps) {
  const theme = useTheme();

  const headerStyle = css`
    display: flex;
    position: fixed;
    left: 50%;
    align-items: center;
    width: 100%;
    max-width: ${breakpoint.mobile_large};
    margin: 0 auto;
    transform: translateX(-50%);
    background: ${transparentBg ? 'transparent' : theme.backgroundColor.base};
  `;

  const headerTypeStyle = css`
    ${type === 'header' &&
    css`
      z-index: ${theme.zIndex.header};
      height: ${theme.layout.chat_header_height};
    `}
    ${type === 'navigation' &&
    css`
      z-index: ${theme.zIndex.navigation};
      bottom: 0;
      height: ${theme.layout.chat_navigation_height};
    `}
  `;

  return (
    <header
      css={css`
        ${headerStyle};
        ${headerTypeStyle};
        top: 0;
      `}
    >
      {children}
    </header>
  );
}
